import { render, staticRenderFns } from "./MsisdnForm.vue?vue&type=template&id=21b9cedf&scoped=true&"
import script from "./MsisdnForm.vue?vue&type=script&lang=js&"
export * from "./MsisdnForm.vue?vue&type=script&lang=js&"
import style0 from "./MsisdnForm.vue?vue&type=style&index=0&id=21b9cedf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b9cedf",
  null
  
)

export default component.exports